import { get, sortBy, merge } from 'lodash';
import { ORDER_ACTIONS } from '../actions';
import { CORE_ACTIONS } from '@ispm/core/constants/core-actions.constant';
import { IOrder, IOrdersState, IOrderStepStatus } from '../../interfaces';
import { IgenomicsAction } from '@ispm/core/interfaces/genomics-action.interface';
import { Map } from 'immutable';

const initialOrderState: IOrdersState = {
  ordersDefinition: null,
  selectedOrder: null,
  ordersData: Map(),
  orderDetailsData: Map(),
  selectedOrderDetails: null,
  currentActiveOrderDetails: null,
  stepStatus: null
};

/**
 * @method orderReducer
 * @param state
 * @param action
 */
export function orderReducer(state: IOrdersState = initialOrderState,
  action: IgenomicsAction<any>): IOrdersState {
  const newState = { ...state };
  switch (action.type) {
    case ORDER_ACTIONS.ADD_ORDER_DETAIL_DEFINITIONS:
      return { ...newState, ordersDefinition: action.payload };
    case ORDER_ACTIONS.ADD_ORDERS:
      newState.ordersData = action.payload;
      newState.stepStatus = getOrderStatus(newState.ordersData);
      return newState;
    case ORDER_ACTIONS.DELETE_ORDER:
      newState.ordersData = newState.ordersData.delete(action.payload.id);
      newState.stepStatus = getOrderStatus(newState.ordersData);
      return newState;
    case ORDER_ACTIONS.UPDATE_ORDER:
      newState.ordersData = newState.ordersData.set(action.payload.id, action.payload.data);
      newState.stepStatus = getOrderStatus(newState.ordersData);
      return newState;
    case ORDER_ACTIONS.CHANGE_SELECTED_ORDER:
      return { ...newState, selectedOrder: action.payload };
    case ORDER_ACTIONS.UPDATE_ORDER_DETAILS:
      newState.orderDetailsData = newState.orderDetailsData.set(action.payload.id, action.payload.data);
      return newState;
    case ORDER_ACTIONS.UPDATE_ORDER_DETAIL:
      newState.orderDetailsData = newState.orderDetailsData.set(action.payload.id, merge(
        newState.orderDetailsData.get(action.payload.id), action.payload.data)
      );
      return newState;
    case ORDER_ACTIONS.CHANGE_SELECTED_ORDER_DETAILS:
      return {
        ...newState,
        selectedOrderDetails: action.payload,
        currentActiveOrderDetails: action.payload.filter(x => x.selected) || null
      };
    case ORDER_ACTIONS.CLEAR_ORDERS:
    case CORE_ACTIONS.CLEAR_ALL_CACHED_ITEMS:
      return { ...initialOrderState };
    default:
      return state;
  }
}

/**
 *
 * @param orders
 */
function getOrderStatus(orders: Map<string, IOrder>): IOrderStepStatus {
  const tempOrders = sortBy(orders.valueSeq().toArray(), o => new Date(get(o, 'dueDate', null)));
  return {
    dueDate: get(tempOrders, '[0].dueDate', null),
    status: get(tempOrders, '[0].status', null)
  };
}
